// extracted by mini-css-extract-plugin
export default {"dismissalCommentTextarea":"BaseSharedDismissalDialog-module__dismissalCommentTextarea--xxBPO"};